//
// AssetInspector
//
// Switch to a specific inspector based on worksheet asset

import { observer } from 'mobx-react-lite'
import { useStore } from '../../stores'

import { View } from '../../appview'
import { FileInspector, FolderInspector } from './inspectors'

export const AssetInspector = observer(function AssetInspector({ worksheet, viewkey }) {
    const { app } = useStore()

    let Inspector = app.text('')
    if (worksheet.asset) {
        if (worksheet.asset.is_file) {
            Inspector = <FileInspector worksheet={worksheet} viewkey={viewkey} />
        } else {
            Inspector = <FolderInspector worksheet={worksheet} viewkey={viewkey} />
        }
    }

    return <View className="panel properties">{Inspector}</View>
})
